// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"772":"MobileChunk","976":"DesktopChunk"}[chunkId] || chunkId) + "." + {"182":"a37c9b9c4fa85ff00eff","772":"8f03e9bc55e013583698","976":"05faadb97218944f0ddf"}[chunkId] + ".css";
};